import { rem } from 'polished';
import styled from 'styled-components';

import { Input } from '@vimeo/iris/components';
import { ChevronRight } from '@vimeo/iris/icons';
import { Header } from '@vimeo/iris/typography';

export const PageControlHeader = styled.header`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 25px;
  > * {
    margin-left: 15px;
  }
`;

export const NoWrapHeader = styled(Header).attrs({ size: '5' })`
  display: flex;
  align-items: center;
  white-space: nowrap;
`;

export const PageControlFooter = styled.footer`
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-items: end;
`;

export const NextButtonWrapper = styled.div`
  @media only screen and (min-width: 768px) {
    transform: translateX(50%);
  }
`;

export const PageControls = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: 15px;

  > * {
    margin: 0 15px;
  }
`;

export const ChevronLeft = styled(ChevronRight)`
  transform: rotate(180deg);
`;

export const PageNumberInput = styled(Input)`
  text-align: center;
  min-width: ${rem(40)};
`;
